import React from 'react'
import DOMPurify from 'dompurify'
import {
  Promo,
  PromoContainer,
  PromoContent,
  PromoMarkup
} from './PromoDetailsNew.styles'
import PromoDetailsNewGlobalStyles from './PromoDetailsNewGlobalStyles'
import { PROMO_SANITIZE_OPTIONS } from '../../utils'
import useReleaseInformationResponsiveBreakpointsV2 from '../../hooks/useReleaseInformationResponsiveBreakpointsV2'

export default function PromoDetailsNew({ promoInfo }) {
  const responsiveBreakpointsV2 = useReleaseInformationResponsiveBreakpointsV2()
  const sanitizedPromoinfoHtml = DOMPurify.sanitize(
    promoInfo,
    PROMO_SANITIZE_OPTIONS
  )

  return (
    <Promo>
      <PromoDetailsNewGlobalStyles />
      <PromoContainer>
        <PromoContent
          $responsiveBreakpointsV2={responsiveBreakpointsV2}
          id="promo-container"
        >
          <PromoMarkup
            className="promo-details-new__content"
            dangerouslySetInnerHTML={{
              __html: sanitizedPromoinfoHtml
            }}
          />
        </PromoContent>
      </PromoContainer>
    </Promo>
  )
}
